import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PersonService } from '../services/person.service';
import { Firestore, collection, query, where, getDocs, Timestamp } from '@angular/fire/firestore';

declare const $: JQueryStatic;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit {
  public trainerInfo: any;
  public trainers: any[];
  public showInfo: any;
  public showId: any;
  public personId: any;
  public personInfo: any;
  public entries: any[];
  public suffix: string;
  constructor(
    private _route: ActivatedRoute,
    private personService: PersonService,
    private firestore: Firestore
  ) {
    this.personId = (this._route.snapshot.params?.personID??'').replace('us_','')??'';
    this.showId = (this._route.snapshot.params?.showID??'').replace('us_','')??'';
    this.suffix = '';
  }

  ngOnInit(): void {
    this.getPersonData(this.personId, this.showId);
  }

  public getPersonData(personId, showId){
    if(!personId || !showId){
      $.NotificationApp.send('Error', 'Invalid person or show ID', 'bottom-right', '#bf441d', 'error');
      return;
    }
    
    const showName = sessionStorage.getItem('showName');
    const showIdSession = sessionStorage.getItem('showId');
    this.suffix = showIdSession.includes('us_') ? 'us_' : '';
    const personIdParam = this.suffix + personId;
    this.personService.getPerson(personId, showId).subscribe(response => {
      this.personInfo = response.data.personInfo;
    });
    this.getResultsByShowAndRider(showName, personIdParam);
  }

  async getResultsByShowAndRider(showName: string, riderId: string): Promise<void> {
    try {
      const resultsRef = collection(this.firestore, 'results');
      const q = query(
        resultsRef,
        where('showName', '==', showName),
        where('riderId', '==', riderId)
      );
      const querySnapshot = await getDocs(q);
      
      // Group results by binomio
      const resultsByBinomio = new Map<string, any[]>();
      querySnapshot.docs.forEach(doc => {
        const data = doc.data();
        const binomio = data.binomio || '';
        if (!resultsByBinomio.has(binomio)) {
          resultsByBinomio.set(binomio, []);
        }
        resultsByBinomio.get(binomio).push(data);
      });

      // Format the results according to resultados.service.ts structure
      this.entries = Array.from(resultsByBinomio.entries()).map(([_, results]) => {
        const firstResult = results[0];
        
        // Format horse information
        const caballo = {
          birth_name: null,
          breed: firstResult.breed || '',
          breed_registry: '',
          breeders_name: '',
          castrated_sterilized: null,
          categoria: null,
          chip_id: '',
          coggins: '',
          color_code: '',
          color_complement: null,
          commercial_prefix: null,
          country_of_birth: firstResult.country_of_birth || '',
          current_name: firstResult.horseName || '',
          dam: firstResult.dam || '',
          date_of_birth: firstResult.date_of_birth || null,
          db: 565,
          deleted: 0,
          ec_data: {
            Status: 'ACTIVE IN SPORT',
            Owner_SLN: 5042500,
            Payment_Date: '2025-04-02T00:00:00',
            Fee_Paid_Year: '2025',
            Horse_Size_CM: 157.48
          },
          ec_id: '149300',
          fei: firstResult.horseFei || '',
          fem: null,
          fullname: firstResult.horseName || '',
          gender: firstResult.gender || '',
          height: firstResult.height || '',
          height_category: null,
          id_caballo: firstResult.horseId ? parseInt(firstResult.horseId.replace('us_', '')) : 0,
          locked: 0,
          modified: new Date().toISOString(),
          notas: null,
          nsba_id: '',
          owner_id: firstResult.riderId ? parseInt(firstResult.riderId.replace('us_', '')) : 0,
          owner_like_usef: null,
          passport: '',
          propietario: firstResult.owner || '',
          shorten_name: null,
          sire: firstResult.sire || '',
          sire_of_dam: firstResult.sire_of_dam || '',
          studbook: null,
          suspensionStatus: null,
          usef_id: '',
          usef_suspended: false,
          usef_suspension_reason: null,
          usef_suspension_status: null,
          usef_suspension_updated: null,
          ushja_id: null,
          ushja_suspended: false,
          ushja_suspension_reason: null,
          ushja_suspension_status: null,
          ushja_suspension_updated: null,
          year: null
        };

        // Format rider information
        const jinete = {
          age: null,
          categoria: firstResult.riderCategory || null,
          celular: '',
          ciudad: '',
          db: 565,
          deleted: false,
          ec_data: {
            Jump: false,
            Amateur: firstResult.amateur || false,
            Dressage: false,
            Eventing: false,
            Province: ''
          },
          ec_id: '',
          email: '',
          entity_type: 'I',
          estado: '',
          fecha_de_nacimiento: '1899-11-30',
          fei: firstResult.riderFei || '',
          foto: firstResult.riderPhoto || '',
          gender: firstResult.gender || ' ',
          id_nacionalidad: null,
          id_persona: firstResult.riderId ? parseInt(firstResult.riderId.replace('us_', '')) : 0,
          lastname: firstResult.riderName ? firstResult.riderName.split(' ').slice(1).join(' ') : '',
          mail_address: {
            zip: '',
            city: '',
            state: '',
            address: '',
            country: ''
          },
          modified: new Date().toISOString(),
          name: firstResult.riderName ? firstResult.riderName.split(' ')[0] : '',
          notas: null,
          phone: '',
          razon_social: '',
          rfc: '',
          stripe_customer_id: '',
          suspensionStatus: '',
          tax_address: {
            zip: '',
            city: '',
            state: '',
            address: '',
            country: ''
          },
          usef_address: {
            zip: '',
            city: '',
            state: '',
            address: '',
            country: ''
          },
          usef_id: firstResult.riderAcronym || '',
          usef_suspended: false,
          usef_suspension_reason: null,
          usef_suspension_status: null,
          usef_suspension_updated: null,
          ushja_id: null,
          ushja_suspended: false,
          ushja_suspension_reason: null,
          ushja_suspension_status: null,
          ushja_suspension_updated: null,
          w9: 0
        };
        // Format competition results
        const resultados = results.map(result => ({
          anterior: 0,
          bloqueo1: null,
          bloqueo2: null,
          calificado_dos: null,
          calificado_uno: result.calificado_uno ? 1 : 0,
          clasificado: null,
          en_pista: null,
          faltas_1: parseInt(result.faults || '0'),
          faltas_2: 0,
          faltas_tiempo_1: 0,
          faltas_tiempo_2: 0,
          fase: null,
          height: result.height || '',
          horse_fall: result.horse_fall || 0,
          id_agrupador: 0,
          id_binomio: result.binomio ? parseInt(result.binomio) : 0,
          id_prueba: result.ipc ? parseInt(result.ipc.replace('us_', '')) : 0,
          order: result.order || 0,
          posicion: result.posicion || null,
          posicion_categoria: null,
          result1: result.result1 || '',
          result2: result.result2 || '',
          result3: result.result3 || '',
          rider_fall: result.rider_fall || 0,
          status_1: result.status_1 || '',
          status_2: null,
          tiempo_1: result.time || '0.000',
          tiempo_2: '0.000',
          video_app: result.video1Url || '',
          video_app_2: result.video2Url || '',
          prueba: {
            id_prueba_concurso: result.ipc ? parseInt(result.ipc.replace('us_', '')) : 0,
            numero: result.classNumber || '',
            fullname: result.className || '',
            inicio:  result.classDate instanceof Timestamp
            ? result.classDate.toDate().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: '2-digit' })
            : result.classDate instanceof Date
              ? result.classDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: '2-digit' })
              : typeof result.classDate === 'string'
                ? new Date(result.classDate).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: '2-digit' })
                : '',
            estatus: result.estatus || 0
          }
        }));

        return {
          caballo,
          customerId: firstResult.customerId || '',
          deleted: 0,
          idCaballo: firstResult.horseId ? parseInt(firstResult.horseId.replace('us_', '')) : null,
          idClub: null,
          idEntrenador: firstResult.riderId ? parseInt(firstResult.riderId.replace('us_', '')) : null,
          idJinete: firstResult.riderId ? parseInt(firstResult.riderId.replace('us_', '')) : null,
          idPropietario: firstResult.riderId ? parseInt(firstResult.riderId.replace('us_', '')) : null,
          idResponsable: firstResult.riderId ? parseInt(firstResult.riderId.replace('us_', '')) : null,
          id_binomio: firstResult.binomio ? parseInt(firstResult.binomio) : null,
          id_concurso: firstResult.ipc ? parseInt(firstResult.ipc.replace('us_', '')) : null,
          jinete,
          locked: 0,
          masterList: '',
          modified: new Date().toISOString(),
          numero: firstResult.entryNumber || '',
          numeroInternacional: null,
          resultados,
          team: null
        };
      });
      console.log('entries', this.entries);
    } catch (error) {
      console.error('Error fetching results:', error);
    }
  }

  public formatDate(date: string): string {
    return new Date(date).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }
}

export interface NotificationApp {
  /**
   * Send Notification
   *
   * @param heading heading text
   * @param body body text
   * @param position position e.g top-right, top-left, bottom-left, etc
   * @param loaderBgColor loader background color
   * @param icon icon which needs to be displayed
   * @param hideAfter automatically hide after seconds
   * @param stack stack
   * @param showHideTransition show hide transition
   */
  send: (
    heading: string,
    body: string,
    position:' bottom-left' | 'bottom-right' | 'bottom-center' | 'top-right' | 'top-left' | 'top-center' | 'mid-center',
    loaderBgColor: string,
    icon: 'error' | 'success' | 'warning' | 'info',
    hideAfter?: number,
    stack?: number,
    showHideTransition?: boolean
  ) => void;
}

export interface JQueryStatic{
  NotificationApp: NotificationApp;
}

